<template>
  <div>
    <gpfs-event v-if="type === 'GPFSEvent'" :event="event" :related="related">
    </gpfs-event>
    <gpprocess-event
      v-else-if="type === 'GPProcessEvent'" :event="event" :related="related">
    </gpprocess-event>
    <gpdownload-event
      v-else-if="type === 'GPDownloadEvent'" :event="event" :related="related">
    </gpdownload-event>
    <gpscreenshot-event
      v-else-if="type === 'GPScreenshotEvent'" :event="event" :related="related">
    </gpscreenshot-event>
    <gpclick-event
      v-else-if="type === 'GPClickEvent'"
      :event="event" :related="related">
    </gpclick-event>
    <gpusb-event
      v-else-if="type === 'GPUSBEvent'" :event="event" :related="related">
    </gpusb-event>
  </div>
</template>

<script>
import gpfsEvent from '@/components/events/GPFSEvent.vue';
import gpprocessEvent from '@/components/events/GPProcessEvent.vue';
import gpdownloadEvent from '@/components/events/GPDownloadEvent.vue';
import gpscreenshotEvent from '@/components/events/GPScreenshotEvent.vue';
import gpclickEvent from '@/components/events/GPClickEvent.vue';
import gpusbEvent from '@/components/events/GPUSBEvent.vue';

export default {
  name: 'EventDetails',
  components: {
    gpfsEvent,
    gpprocessEvent,
    gpdownloadEvent,
    gpscreenshotEvent,
    gpclickEvent,
    gpusbEvent,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
};
</script>
